<template>
<div>

	<!-- page-heading -->
	<page-heading :show="true" pageTitle="ECC-HEADER"></page-heading>

	<div class="columns">

		<div class="col-main">

			<!-- show loading indicator -->
			<loading-indicator :loading="isLoading"></loading-indicator>

			<template v-if="!isLoading">

				<v-client-table ref="tblEquipmentCategories" name="tblEquipmentCategories" :data="table.tblData" :columns="table.tblColumns" :options="table.tblOptions" class="tblEquipmentCategories noFirstColumn">

					<!-- before table: FILTER OPTIONS -->
	                <template slot="beforeTable">

						<!-- SEARCH -->
						<div class="control has-icon search is-pulled-left">
							<input class="input" type="text" v-model.trim="searchString" placeholder="Suchbegriff">
							<i class="fa fa-search" aria-hidden="true"></i>
						</div>

						<div class="is-pulled-right">
							<div class="columns is-marginless filters">

								<div class="column is-narrow">

									<!-- show Categories *not* in catalog switcher -->
									<div class="control is-horizontal is-pulled-right">

										<div class="control-label">
											<label-name labelKey="ECC-FILTER-SHOW_CATEGORIES_NOT_IN_CATALOG"></label-name>
										</div>

										<div style="padding-top: 7px">
											<b-switch v-model.sync="showCategoriesNotInCatalog" type="primary" class="is-small"></b-switch>
										</div>

									</div>

								</div>

	                    	</div>

						</div>

	                </template>


					<!-- pages -->
					<template slot="pages" slot-scope="props">
						<template v-for="(page, index) in props.row.pages">
							<router-link :to="{ name: 'equipmentCatalogPage', params: { 'equipmentCatalogPageID': page.id }}" class="page">{{ (page.pageIndex + 1) }}</router-link><template v-if="index != props.row.pages.length-1">, </template>
						</template>

					</template>

					<!-- aliases -->
					<template slot="aliases" slot-scope="props">
						<template v-for="(alias, index) in props.row.aliases" v-if="props.row.aliases.length > 0">
							{{ alias.alias.name }}<template v-if="index != props.row.aliases.length-1">, </template>
						</template>
					</template>

					<!-- delete -->
					<template slot="delete" slot-scope="props">

						<span :class="[ {'is-disabled': props.row.pages.length > 0 }, 'del icon is-small']" @click="deleteCategory(props)">
							<i class="icon-ak-entfernen"></i>
						</span>

					</template>

				</v-client-table>

			</template>

		</div>

        <div class="col-aside">

    		<affix :offset="50">

                <div class="sidebox">
					<custom-button type="blue" name="ECC-BTN-CATEGORY_ADD" icon="icon-ak-hinzufuegen" @click.native="newCategory"></custom-button>
				</div>

    		</affix>

        </div>

    </div>

</div>

</template>





<script>
import Vue from 'vue';
import { ClientTable, Event } from 'vue-tables-2';
Vue.use(ClientTable, {}, false, 'bulma');

export default {

    name: 'equipmentCategories',

	components: {

	},

	data() {

        return {
            isLoading: true,
            searchString: null,
			showCategoriesNotInCatalog: false,
            table: {

                tblColumns: ['name', 'pages', 'aliases', 'delete'],
                tblData: [],
                tblOptions: {
                    trackBy: 'id',
                    uniqueKey: 'id',
                    saveState: true,
                    perPage: 25,
                    orderBy: {
                        ascending: true,
                        column: 'name'
                    },

                    // custom table headings - make them clickable for language Setting
                    headings: {

                        name: function(h) {
                            return <lang labelKey="ECC-TBL_HEADER-NAME"></lang>
                        },
						pages: function(h) {
                            return <lang labelKey="ECC-TBL_HEADER-PAGES"></lang>
                        },
						aliases: function(h) {
                            return <lang labelKey="ECC-TBL_HEADER-ALIASES"></lang>
                        },
						delete: function(h) {
                            return <lang labelKey="ECC-TBL_HEADER-DELETE"></lang>
                        },
                    },

                    sortable: ['name'],
					sortIcon: {
                        base:'fa',
                        up:'fa-sort-up',
                        down:'fa-sort-down',
                        is:'fa-sort'
                    },
                    filterByColumn: false,
                    filterable: false,

                    texts: {
                        filter: 'Filter Ergebnisse:',
                        filterPlaceholder: 'Suche',
                        limit: 'Einträge pro Seite',
                        noResults: 'keine passenden Einträge gefunden',
                        count: '{from} bis {to} von {count} Einträgen|{count} Einträge|ein Eintrag'
                    },

                    pagination: {
                        chunk: 5
                    },

                    skin: 'table is-striped is-hoverable is-fullwidth',

                    templates: {

                        category: function(h, row) {
                            return self.equipmentCategories.find(cat => cat.id == row.category).name;
                        },

                        priceAEP: function(h, row) {
                            return self.formatPoint2Comma(row.priceAEP);
                        },

                    },

                    // custom filter functions
                    customFilters: [
                        {
                            name: 'search',
                            callback: function(row, string) {

                                if(string == null || string == "") {
                                    return true;
                                }

                                string = string.toLowerCase();

                                return row.name != null && row.name.toLowerCase().indexOf(string) >= 0;

                            }
                        },
						{
                            name: 'notInCatalog',
                            callback: function(row, showNotInCatalog) {

								if(showNotInCatalog == false) {

									return true;

								} else if(row.pages.length == 0) {

									return true;

								}
                            }
                        }
                    ],

                    rowClassCallback: function(row) {

                    }

                }
            }

        }
    },

    created() {

        this.fetchData();

    },

    mounted() {

        Event.$on('vue-tables.tblEquipmentCategories.row-click', function (data) {

			if(['icon-ak-entfernen', 'page'].indexOf(data.event.target.className) > -1) {
				return false;
			}

            this.$router.push({ name: 'equipmentCategory', params: { 'equipmentCategoryID': data.row.id }  });

        }.bind(this));

    },

	watch: {

		searchString(val) {
			Event.$emit('vue-tables.tblEquipmentCategories.filter::search', val);
		},

		showCategoriesNotInCatalog(val) {
			Event.$emit('vue-tables.tblEquipmentCategories.filter::notInCatalog', val);
		}

	},


    methods: {

        newCategory() {
            this.$router.push({ name: 'equipmentCategoryNew' });
	    },

		deleteCategory(props) {

			// find the index of the clicked row first
			var foundIndex = "";
			this.table.tblData.forEach(function(row, index) {
				if(row.id == props.row.id) {
					foundIndex = index;
				}
			})

			// if we found an index, delete the category in the DB
			// and remove it from the array
			if(foundIndex != "") {

				var self = this;
				this.entityDelete('equipmentCategory', this.table.tblData[foundIndex].id, 'ECC-MSG-CONFIRM_DELETION')
					.then(function(response) {
						self.table.tblData.splice(foundIndex, 1);
					})
			}

		},

        fetchData() {

			this.isLoading = true;
			var self = this;

			// make the request
			this.axios.get(self.$config.api + 'equipmentCategory?include=equipmentCategory.pages')
                .then(function(response) {

					self.table.tblData = response.data.equipmentCategory;
					self.isLoading = false;

                }).catch(function(error) {
                    self.isLoading = false;
					console.log(error);
				});
		},

    }

}
</script>


<style>
	.tblEquipmentCategories th:nth-child(2) {
		width: 150px;
	}

	.tblEquipmentCategories th:last-child,
	.tblEquipmentCategories td:last-child {
		width: 100px;
		text-align: center;
	}
	.tblEquipmentCategories td:last-child .is-disabled {
		color: #eee;
	}

</style>
